import './font-faces.css';
import { importSVGs } from '@powdr/utils';

import { config } from './config';
import { fontTheme } from './fonts';
import { overrides } from './overrides';
import {
  defaultTheme, altTheme, wwDefaultTheme, wwAltTheme, StaticTheme,
} from './themes';

const theme = {
  svgs: { ...importSVGs(require.context('../assets/svgs', true, /\.svg$/)) },
  defaultTheme,
  altTheme,
  wwDefaultTheme,
  wwAltTheme,
  StaticTheme,
  config,
  ...fontTheme,
  overrides: { ...overrides },
};

export default theme;
